var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"flex-grow"},[_vm._t("main")],2),_vm._v(" "),_c('div',{staticClass:"flex-shrink-0 w-84 ml-8"},[_c('div',{ref:"side"},[_vm._t("side")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }